import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'

export enum DeviceType {
  Mobile,
  Desktop
}

export interface AppState {
  device: DeviceType,
  sidebar: {
    opened: boolean
  }
}

@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements AppState {
  public sidebar = {
    opened: true
  };
  public device = DeviceType.Desktop;

  @Mutation
  private TOGGLE_SIDEBAR() {
    this.sidebar.opened = !this.sidebar.opened;

  }

  @Action
  public ToggleSideBar() {
    this.TOGGLE_SIDEBAR();
  }

  @Mutation
  private TOGGLE_DEVICE(device: DeviceType) {
      this.device = device;
      if (device === DeviceType.Mobile) {
        this.sidebar.opened = false;
      }
  }

  @Action
  public ToggleDevice(device: DeviceType) {
      this.TOGGLE_DEVICE(device);
  }
}

export const AppModule = getModule(App)